import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#f5f5f5] py-8 md:py-16 px-4 border-t-4 border-gray-300" data-id="element-220">
      <div className="max-w-3xl mx-auto" data-id="element-221">
        <div className="bg-white p-6 md:p-12 rounded-lg border-l-8 border-[#c41e3a] shadow-lg" data-id="element-222">
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase mb-3" data-id="element-223">
            ¿Por qué muchos barberos no avanzan?
          </p>
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-4 md:mb-6 leading-tight" data-id="element-224">
            El problema no es la técnica.{' '}
            <span className="text-[#c41e3a]" data-id="element-225">Es la falta de criterio.</span>
          </h2>
          <div className="w-12 h-0.5 bg-[#c41e3a] mb-4 md:mb-6" data-id="element-226"></div>
          <p className="text-sm md:text-lg text-gray-600 leading-relaxed mb-4 md:mb-5" data-id="element-227">
            La mayoría de los cursos te muestran qué hacer, pero no te explican{' '}
            <strong className="text-gray-900" data-id="element-228">por qué hacerlo</strong>. Eso
            genera inseguridad, errores que se repiten y cortes inconsistentes.
          </p>
          <p className="text-sm md:text-lg text-gray-900 font-black" data-id="element-229">
            El Método Barber Pro existe para darte ese criterio. Para que cada
            decisión que tomés en la silla tenga fundamento.
          </p>
        </div>
      </div>
    </section>;
}